import { TreeNode } from "@/types/tree";

export type SectionCategory = string;

export type SingularitySectionLibrary = {
  [key: SectionCategory]: TreeNode[];
};

let singularitySectionLibrary: SingularitySectionLibrary = {};

export function setSingularitySectionLibrary(library: SingularitySectionLibrary) {
  console.log("Setting singularity section library", library);
  singularitySectionLibrary = library;
}

export function getSingularitySectionLibrary() {
  return singularitySectionLibrary;
}

export function isSingularitySectionLibraryLoaded(): boolean {
  return Object.keys(singularitySectionLibrary).length > 0;
}
